import { render, staticRenderFns } from "./TaxonomyChrome.vue?vue&type=template&id=a13bffa4&scoped=true&"
import script from "./TaxonomyChrome.vue?vue&type=script&lang=js&"
export * from "./TaxonomyChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13bffa4",
  null
  
)

export default component.exports